<template>
  <page>
    <b-row>
      <b-col cols="12" sm="8" offset-sm="2">
        <h1 class="border-bottom mb-3">Frequently Asked Questions</h1>
        <div id="toc"/>
        <markdown class="markdown-content my-3" :source="source"
          toc :toc-anchor-link="false" toc-first-level="1" toc-last-level="3" toc-id="toc"/>
      </b-col>
    </b-row>
  </page>
</template>

<script>
import Page from '@/components/Page';
import Markdown from 'vue-markdown';
import source from '@/assets/help/recruiter.md';

export default {
  components: {
    Page,
    Markdown,
  },
  metaInfo: {
    title: 'Recruiter FAQs',
  },
  computed: {
    source: () => source
  },
};
</script>



// WEBPACK FOOTER //
// src/views/static/help/recruiter.vue